import IMask from "imask"

export const currencyMask = (max: number, addMoneySymbol = true, includeCentsIfUserDoesntTypeIt = true) => {
  return [{
    mask: `${addMoneySymbol ? 'R$ ' : ''}num`,
    blocks: {
      num: {
        mask: Number,
        max: max,
        thousandsSeparator: '.',
        padFractionalZeros: includeCentsIfUserDoesntTypeIt,
        min: 0,
        radix: includeCentsIfUserDoesntTypeIt ? ',' : undefined, // The decimal separator
        scale: includeCentsIfUserDoesntTypeIt ? 2 : 0, // Number of decimal places
        signed: false,
        normalizeZeros: false, // Keeps the zeros in the decimal part
      }
    }
  }]
}

export const numberMask = (max: number, includeDecimals = false, decimals?: number) => {
  return [{
    mask: 'num',
    blocks: {
      num: {
        mask: Number,
        max: max,
        thousandsSeparator: '.',
        padFractionalZeros: includeDecimals,
        min: 0,
        radix: includeDecimals ? ',' : undefined,
        scale: includeDecimals ? (decimals || 2) : 0,
        autofix: true,
      }
    }
  }]
}

export const percentageMask = [{
  mask: 'num %',
  lazy: false,
  blocks: {
    num: {
      mask: Number,
      max: 100,
      min: 0
    }
  }
}]

export const percentageMaskAllowNegative = [{
  mask: 'num %',
  lazy: false,
  blocks: {
    num: {
      mask: Number,
      signed: true,
      max: 100,
      min: -100,
    }
  }
}]

export const nameMask = [{
  mask: 'char',
  lazy: false,
  blocks: {
    char: {
      mask: /^[a-záàâãéèêíïóôõöúçñ\s]+$/i,
    }
  }
}]

export const phoneMask = [
  '+{55} (00) 0000-0000',
  '+{55} (00) 00000-0000'
]

export const cpfMask = "000.000.000-00";

export const cnpjMask = '00.000.000/0000-00'

export const cnpjCpfMask = IMask.createMask({
  mask: [
    { mask: cnpjMask },
    { mask: cpfMask }
  ],
  dispatch: (appended, dynamicMasked) => {
    const value = (dynamicMasked.value + appended)?.replace(/\D/g, '')

    if(value.length > 11) {
      return dynamicMasked.compiledMasks[0]
    }

    return dynamicMasked.compiledMasks[1];
  }
})

export const dateMask = {
  mask: Date,
  min: new Date(1900, 0, 1),
  max: new Date(),
  lazy: false
}

export const timeMask = [{
  mask: 'HH:mm',
  blocks: {
    HH: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 23,
    },
    mm: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 59,
    }
  }
}];

export const customUnitMask = (unit: string, max?: number, decimal = false, decimals?: number) => {
  return [{
    mask: `num ${unit}`,
    lazy: false,
    blocks: {
      num: {
        mask: Number,
        max: max || 999999,
        min: 0,
        padFractionalZeros: decimal,
        radix: decimal ? ',' : undefined,
        scale: decimal ? (decimals || 3) : 0,
      }
    }
  }]
}

export const stateInscriptionMask = [
  'ISENTO',
  '00000000000000',
]

export const numericRegexMask = (length: number) => {
  return new RegExp(`^\\d{0,${length}}$`)
}

export const alphaNumericRegexMask = (length: number) => {
  return new RegExp(`^[a-zA-Z0-9]{0,${length}}$`)
}
